import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/** Theme radius keys used by Swivu (`rounded-gummy-*` in Tailwind). */
const gummyBorderRadius = [
  "gummy-2xs",
  "gummy-xs",
  "gummy-sm",
  "gummy-md",
  "gummy-lg",
  "gummy-xl",
  "gummy-tile"
] as const;

const twMerge = extendTailwindMerge({
  theme: {
    borderRadius: [...gummyBorderRadius]
  },
  classGroups: {
    "text-shadow": ["text-shadow-on-color", "text-shadow-on-color-strong"]
  }
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
